import { z } from 'zod';

const requiredStringSchema = z.string().min(1);

export const userSchema = z.object({
  Id: requiredStringSchema,
  Name: requiredStringSchema,
  Email: z.string().optional(),
  CurrentVesselId: z.string().optional(),
  DutyRankId: z.string().optional(),
  CompanyId: z.string().optional(),
  IsActive: z.boolean().optional()
});

export const userArraySchema = z.array(userSchema);

export const usersApiResponseSchema = z.object({
  Data: userArraySchema
});

export type User = z.infer<typeof userSchema>;
export type UserArray = z.infer<typeof userArraySchema>;
export type UsersApiResponse = z.infer<typeof usersApiResponseSchema>;
